<!--
cdkDropListOrientation=mixed siden vi bruker grid-layout
setter ikke cdkDropListLockAxis="y", vi sørger for at kun vertikal bevegelse er mulig via cdkDragConstrainPosition
Se https://material.angular.io/cdk/drag-drop/overview#styling for oversikt over css klasser benyttet av cdkDrop
-->
<div cdkDropList
     (cdkDropListDropped)="radFlyttet($event)"
     [cdkDropListSortPredicate]="flyttingTillatFn()"
     [cdkDropListDisabled]="!redigeringMulig()"
     cdkDropListOrientation="mixed"
     class="saker"
     #sakerKontainer>
  <!--dersom du trenger å se placeholder kontainer statisk-->
  <!--<div class="sak-placeholder-kontainer cdk-drag-placeholder"></div>-->
  @for (rad of rader(); track rad.id; let indeks = $index) {
    @if (rad.dag) {
      <div class="dag" cdkDrag [cdkDragData]="rad" [cdkDragDisabled]="indeks == 0" [cdkDragConstrainPosition]="dagPreviewKontainerPlasseringFn()" (cdkDragStarted)="flyttingAvDagStartet($event)" data-testid="dag"> <!-- første dag kan ikke flytte -->
        <span class="dagnummer" data-testid="dagnummer">{{ 'Dag {nummer}'|translate:{nummer: rad.dag.dagNummer+1} }}</span>
        <span class="dato">{{rad.dag.dato | zoneddatetimeSomPlaindate | plaindate:'full'}}</span>
        @if(sorteringAktivert()){
          <span class="klokkeslett" matTooltip="{{'Starttidspunkt for første dag er lik møtets starttidspunkt og kan endres ved å redigere møte'|translate}}" [matTooltipDisabled]="indeks != 0">
            <i class="ion-ios-clock-outline"></i>
            <klokkeslett-velger [formControl]="rad.dag!.startTidspunktKontroll" placeholder="hh:mm"/>
            @if(rad.dag.startTidspunktKontroll.invalid){
              <span class="valideringsfeil">{{'ugyldig klokkeslett'|translate}}</span>
            }
          </span>
        }
        <!-- placeholder kontainer som representerer plassen i listen der element som flyttes havner når bruker slipper musemarkøren -->
        <div *cdkDragPlaceholder class="dag dag-placeholder-kontainer"></div>
      </div>
    } @else {
      <!-- uten cdkDragPreviewContainer=parent treffer ikke selectoren .sak-preview-kontainer korrekt i css -->
      <sak-listevisning [sak]="rad.sak!.sak"
                        [tidspunkt]="rad.sak!.tidspunkt"
                        [varighetKontroll]="rad.sak!.varighetKontroll"
                        [kompakt]="visKompakt()"
                        [ekstraKompakt]="ekstraKompakt()"
                        [sorteringAktivert]="sorteringAktivert()"
                        [utenSortering]="!redigeringMulig()"
                        [holdSynligVedEndringAv]="rader().length"
                        (vedHandling)="vedHandling($event, rad, indeks)"
                        cdkDrag
                        cdkDragPreviewContainer="parent"
                        [cdkDragConstrainPosition]="sakPreviewKontainerPlasseringFn()"
                        [cdkDragData]="rad"
                        (cdkDragStarted)="flyttingAvSakStartet($event)"
                        [class.flyttet]="rad.erFlyttet">
        <!-- preview kontainer som vises ved musemarkør når man flytter sak, må definere en *cdkDragPreview da sak-listevisning elementet er
          deklarert med display:contents som gjør at elementet ikke har noen utstrekning (bredde/høyde) og da får elementet som dras stilingen width:0 height:0
          hvorpå innholdet ikke vises -->
        <div *cdkDragPreview class="sak-preview-kontainer">
          <sak-listevisning [sak]="rad.sak!.sak" [tidspunkt]="rad.sak!.tidspunkt" [kompakt]="visKompakt()"/>
        </div>
        <!-- placeholder kontainer som representerer plassen i listen der element som flyttes havner når bruker slipper musemarkøren -->
        <div *cdkDragPlaceholder class="sak-placeholder-kontainer"></div>
      </sak-listevisning>
    }
  }
</div>

<!--dersom du trenger å se preview kontainer statisk-->
<!--<div  class="sak-preview-kontainer">
  <sak-listevisning [sak]="rader()[1].sak!.sak" [tidspunkt]="rader()[1].sak!.tidspunkt"/>
</div>-->

@if(sorteringAktivert()){
 <div class="sortering-endret-handlinger" navigasjonforhindret-flash>
   <button mat-raised-button color="primary" (click)="lagreNySortering()" [disabled]="skjema.invalid || lagrer()">{{'Lagre ny saksrekkefølge'|translate}}</button>
   <button mat-stroked-button (click)="avbrytNySortering()">{{'avbryt'|translate}}</button>

   @if(antallSakerSomManglerVarighet() > 0){
     <inline-melding type="info-transparent">
       {{'{antall} saker mangler varighet'|translate: {antall:antallSakerSomManglerVarighet()} }}
     </inline-melding>
   }
 </div>
}
